<zxing-scanner (scanComplete)="scanned($event)"></zxing-scanner>
